export const extractPlayerList = (type, data) => {
  let playerIdMap = {}, playerNames = [], playerIdsInOrder = []
  for (const p of data) {
    let id, name, classTag
    if (type === 'pitcher') {
      id = p['投手編號']
      name = p['投手']
      classTag = p['左右投']
    } else {
      id = p['打者編號']
      name = p['打者']
      classTag = p['內外野捕手']
    }
    playerIdMap[id] = { name, tag: classTag }
    playerNames.push(name)
    playerIdsInOrder.push(id)
  }
  return { idMap: playerIdMap, names: playerNames, ids: playerIdsInOrder }
}